// Shared brand assets + content for Yogiinit.
export const BRAND = {
  name: "Yogiinit",
  tagline: "Heal. Balance. Thrive.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_luxury-yoga-studio/artifacts/q0hesr7z_yogiinit-removebg-preview.png",
  heroVideoUrl:
    "https://customer-assets.emergentagent.com/job_luxury-yoga-studio/artifacts/rieyvojd_For%20Website%20first%20page.mp4",
  heroFallbackImage:
    "https://images.unsplash.com/photo-1761971975962-9cc397e2ba2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB5b2dhJTIwc3R1ZGlvfGVufDB8fHx8MTc3NzMxMDA4NXww&ixlib=rb-4.1.0&q=85",
  founderImage:
    "https://customer-assets.emergentagent.com/job_luxury-yoga-studio/artifacts/0hbno7qv_IMG_20260510_105703514~3.jpg",
  contact: {
    email: "hello@yogiinit.com",
    phone: "+91 98674 13477",
    phoneHref: "tel:+919867413477",
    whatsapp: "https://wa.me/919867413477",
    instagram: "https://instagram.com/yogiinit",
    youtube: "https://youtube.com/@yogiinit",
    facebook: "https://facebook.com/yogiinit",
  },
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Classes", href: "/classes" },
  { label: "Products", href: "/products" },
  { label: "About Us", href: "/about" },
  { label: "Contact Us", href: "/contact" },
];
